import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs whent the authroization token is expiredd.
 */
export class ExpiredTokenException extends CoreUiException {

    /**
     * Is true if its been handled already
     */
    tokenErrorHandled = false;

    constructor(originalError?: any) {

        super("ExpiredToken", "Your session has expired. Please login again.", originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ExpiredTokenException.prototype);
    }
}
